/**
 * @generated SignedSource<<675711350171775abc6d82cc58229428>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSiteMutation$variables = {
  address?: string | null;
  address2?: string | null;
  city?: string | null;
  id: string;
  key: string;
  name: string;
  regionId?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdateSiteMutation$data = {
  readonly updateSite: {
    readonly address: string | null;
    readonly address2: string | null;
    readonly city: string | null;
    readonly id: string;
    readonly key: string;
    readonly name: string;
    readonly state: string | null;
    readonly zip: string | null;
  };
};
export type UpdateSiteMutation = {
  response: UpdateSiteMutation$data;
  variables: UpdateSiteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address2"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zip"
},
v9 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "address",
            "variableName": "address"
          },
          {
            "kind": "Variable",
            "name": "address2",
            "variableName": "address2"
          },
          {
            "kind": "Variable",
            "name": "city",
            "variableName": "city"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
          },
          {
            "kind": "Variable",
            "name": "zip",
            "variableName": "zip"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      },
      {
        "kind": "Variable",
        "name": "regionId",
        "variableName": "regionId"
      }
    ],
    "concreteType": "Site",
    "kind": "LinkedField",
    "name": "updateSite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address2",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zip",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateSiteMutation",
    "selections": (v9/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateSiteMutation",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "d40bda2274f0ddbcfb3a6d1a3bbcd8fd",
    "id": null,
    "metadata": {},
    "name": "UpdateSiteMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateSiteMutation(\n  $id: ID!\n  $key: String!\n  $name: String!\n  $address: String\n  $address2: String\n  $city: String\n  $state: String\n  $zip: String\n  $regionId: String\n) {\n  updateSite(regionId: $regionId, input: {id: $id, key: $key, name: $name, address: $address, address2: $address2, city: $city, state: $state, zip: $zip}) {\n    id\n    key\n    name\n    address\n    address2\n    city\n    state\n    zip\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc8b0510228e362a3770e5abb3d1bda8";

export default node;
